module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic.58b98b5.ttf";